// extracted by mini-css-extract-plugin
module.exports = {"selector":"Selector_selector__1EQ1O"};